import { render, staticRenderFns } from "./advancedSlice.vue?vue&type=template&id=8fca7396&scoped=true"
import script from "./advancedSlice.vue?vue&type=script&lang=js"
export * from "./advancedSlice.vue?vue&type=script&lang=js"
import style0 from "./advancedSlice.vue?vue&type=style&index=0&id=8fca7396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fca7396",
  null
  
)

export default component.exports